import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { SingleProjectToTargetComponentBase } from 'common-ui';

@Component({
  selector: 'ideal-render-target-product-details-title',
  standalone: true,
  imports: [],
  template: ``,
  styles: `
    :host {
      display: grid;
      grid-template-columns: 1fr 1.75em;
      grid-auto-rows: auto;
      grid-auto-flow: row;
      gap: 0.1em;
      > * {
        // grid-column: 1 / 2;
        grid-column: 1;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailTitleRenderTargetComponent extends SingleProjectToTargetComponentBase {
  public override readonly context = undefined;
  protected readonly renderInElements = computed(() => this.renderNodes().map((node) => this.element));
}
